module.exports = __webpack_public_path__ + "img/4bb8782.png";